import BeforeAutocompleteInput from "./BeforeAutocompleteInput";
import CustomAutocompleteInput from "./CustomAutocompleteInput";
const CustomFilterSelect = ({ ...props }) => {
  const before = props?.before;
  // const authrole = localStorage?.getItem("authrole")?.toString();
  if (before == "and") {
    return (
      <>
        <BeforeAutocompleteInput {...props} />
      </>
    );
  } else {
    return (
      <>
        <CustomAutocompleteInput {...props} />
      </>
    );
  }
};
export default CustomFilterSelect;
